import { render } from "./DartsCalculator.vue?vue&type=template&id=56f519a8&scoped=true"
import script from "./DartsCalculator.vue?vue&type=script&lang=js"
export * from "./DartsCalculator.vue?vue&type=script&lang=js"

import "./DartsCalculator.vue?vue&type=style&index=0&id=56f519a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f519a8"]])

export default __exports__